import React, { useContext, useEffect, useState } from 'react';
import { ButtonComp } from 'atoms/Buttons';
import { useDispatch, useSelector } from 'react-redux';
import {
  addItemToCartAction,
  removeCouponAction,
  setUserLastActiveTime,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import { CheckoutDetailsClick } from 'common/utilities/analyticsUtils';
import AddHope from 'styles/staticAssets/images/add_hope.png';
import OffersCoupon from '../ReusableComponents/OffersCoupon';
import { CART_PAGE_CONSTANTS } from '../../Constants/CartPageConstants';
import FoodItemListHandlers from '../ReusableComponents/FoodItemListHandlers';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { getAddHopeItem, getCarryBagItem, isEmptyObject, getTernaryValue } from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { LOCAL_STORAGE_KEYS, CLOSED } from 'common/constants/SharedConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const { CircleCloseButton, Ellipse } = IMAGE_PATH;
const setDataObject = (data, setDataId, setDataPrice) => {
  if (isEmptyObject(data)) {
    setDataId(data.id);
    setDataPrice(data.price);
  } else {
    setDataId('');
    setDataPrice(0);
  }
};

const setDataInCartObject = (data, setDataFoodLineId) => {
  if (isEmptyObject(data)) {
    setDataFoodLineId(data.id);
  } else {
    setDataFoodLineId('');
  }
};

const checkToDisableCheckout = (dispositionNew, setDisableCheckout) => {
  dispositionNew &&
    setDisableCheckout(
      (dispositionNew?.store?.summary?.status?.currentStatus === CLOSED ||
        !dispositionNew?.store?.summary?.timings?.scheduled?.periods.length) &&
        dispositionNew?.time === '',
    );
};

function getExpiryMessage(expiryMessage) {
  return (
    <>
      {expiryMessage && (
        <div className='cart-summary-discount-lines'>
          <div>
            <div className='discount-error'>
              <img className='discount-error-icon' src={Ellipse} alt='close' />
              <span>{expiryMessage}</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const CartSummaryCard = props => {
  const {
    contentData = {},
    currencySymbol = '',
    currencyConversionFactor = '',
    addHope = '',
    carryBag = '',
    bucketId = '',
    isMobile,
    tenantId = '',
    confirmChangesHandler,
    dispositionData = {},
  } = props;
  const {
    totalAmount = '',
    quantity = '',
    additionalCharges = [],
    discountAmounts = [],
    subTotal = '',
    taxAmounts = '',
  } = contentData;
  const dispatch = useDispatch();
  const { itemRemoveHandler } = FoodItemListHandlers(
    { cartId: bucketId },
    tenantId,
    undefined,
    undefined,
    undefined,
    dispatch,
    undefined,
  );
  const { CART_SUMMARY_CARD = {}, FROMCHECKOUT = '' } = CART_PAGE_CONSTANTS;
  const {
    QUANTITY_TEXT,
    QUANTITYS_TEXT,
    SUBTOTAL,
    ADD_HOPE_HEADER,
    ADD_HOPE_TEXT,
    CHECKOUT,
    CARRY_BAG,
    TAKEAWAY,
    RESTAURANT_HANDLING_CHARGE,
    GST,
    DONATE,
    addHopeText,
    largeCarryBagText,
    SEARCH_IN_MENU,
    SEARCH_IN_CART,
  } = CART_SUMMARY_CARD;
  const [checkoutButton, setCheckoutButton] = useState(false);
  const { flatResponse: { specialItemMapByName = {} } = {} } = useSelector(({ menuReducer }) => menuReducer) ?? {};
  const cartReducer = useSelector(data => data.cartReducer);
  const { cartData = {} } = cartReducer || {};
  const [addHopeDataId, setAddHopeDataId] = useState();
  const [addHopeDataPrice, setAddHopeDataPrice] = useState(0);
  const [carryBagDataId, setCarryBagDataId] = useState();
  const [carryBagDataPrice, setCarryBagDataPrice] = useState(0);
  const [addHopeDataExistsInCartId, setAddHopeDataExistsInCartId] = useState();
  const [carryBagDataExistsInCartId, setCarryBagDataExistsInCartId] = useState();
  const [disableCheckout, setDisableCheckout] = useState(false);

  const { userOrderState } = useContext(UserOrderContext);
  const expiryMessage = localStorage.getItem('expiryMessage');
  const dispositionNew =
    JSON?.parse(localStorage?.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW)) ?? userOrderState?.dispositionNew;

  useEffect(() => {
    checkToDisableCheckout(dispositionNew, setDisableCheckout);
  }, [dispositionNew]);

  useEffect(() => {
    if (specialItemMapByName) {
      let addHopeData = getAddHopeItem(specialItemMapByName, addHope, currencyConversionFactor, SEARCH_IN_MENU);
      setDataObject(addHopeData, setAddHopeDataId, setAddHopeDataPrice);
      let carryBagData = getCarryBagItem(specialItemMapByName, carryBag, currencyConversionFactor, SEARCH_IN_MENU);
      setDataObject(carryBagData, setCarryBagDataId, setCarryBagDataPrice);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specialItemMapByName]);

  useEffect(() => {
    if (cartData && !cartData?.errorCode) {
      let addHopeDataExistsInCart = getAddHopeItem(
        cartData.foodLines,
        addHope,
        currencyConversionFactor,
        SEARCH_IN_CART,
      );
      setDataInCartObject(addHopeDataExistsInCart, setAddHopeDataExistsInCartId);
      let carryBagDataExistsInCart = getCarryBagItem(
        cartData.foodLines,
        carryBag,
        currencyConversionFactor,
        SEARCH_IN_CART,
      );
      setDataInCartObject(carryBagDataExistsInCart, setCarryBagDataExistsInCartId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData?.errorCode, cartData?.foodLines]);

  const addSpecialItemInCart = (event, foodLineId) => {
    event.stopPropagation();
    event.preventDefault();
    let isChecked = event.target.checked;
    let inputId = event.target.id;
    if (isChecked) {
      dispatch(
        addItemToCartAction(
          {
            params: {
              basketId: bucketId,
            },
            tenantId: tenantId,
          },
          [{ Id: inputId, categoryId: '', quantity: 1, modGrps: [] }],
        ),
      );
    } else {
      let item = { foodLineId, flag: 'specialItems' };
      itemRemoveHandler(item);
    }
    dispatch(setUserLastActiveTime(new Date()));
  };

  const isInViewport = element => {
    const rect = element.getBoundingClientRect();
    return (
      (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) ||
      (rect.top < 0 && rect.bottom < 0) ||
      (rect.top <= 0 && rect.bottom > 0)
    );
  };

  const checkIsInViewport = () => {
    const element = document.getElementById('summary-card');
    const summaryCart = isInViewport(element);
    setCheckoutButton(summaryCart);
  };

  const removeCouponHandler = couponCode => {
    localStorage.removeItem('expiryMessage');
    dispatch(
      removeCouponAction({
        basketId: bucketId,
        tenantId,
        couponCode,
      }),
    );
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('scroll', checkIsInViewport);
    }
    return () => {
      document.removeEventListener('scroll', checkIsInViewport);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigateToCheckout = e => {
    e.stopPropagation();
    e.preventDefault();
    confirmChangesHandler(FROMCHECKOUT);
    CheckoutDetailsClick();
  };

  return (
    <div className='cart-summary-card' id='summary-card' data-testid='cart-summary-card-test'>
      <h2 className='cart-summary-item-count'>
        {quantity}{' '}
        {getTernaryValue(quantity === 1, translateWithI18Next(QUANTITY_TEXT), translateWithI18Next(QUANTITYS_TEXT))}
      </h2>
      <div className='cart-summary-coupons'>
        <OffersCoupon bucketId={bucketId} />
      </div>
      <div className='cart-summary-content'>
        <div className='cart-summary-content-item'>
          <div className='cart-summary-content-item-name'>{translateWithI18Next(SUBTOTAL)}</div>
          <div className='cart-summary-content-item-value'>
            {currencySymbol}
            {subTotal}
          </div>
        </div>
        <div className='cart-summary-content-item'>
          <div className='cart-summary-content-item-name'>{translateWithI18Next(GST)}</div>
          <div className='cart-summary-content-item-value'>{taxAmounts}</div>
        </div>

        {additionalCharges.length > 0 &&
          additionalCharges.map((item, idx) => {
            return (
              <div key={idx} className='cart-summary-content-item'>
                <div className='cart-summary-content-item-name'>{translateWithI18Next(RESTAURANT_HANDLING_CHARGE)}</div>
                <div className='cart-summary-content-item-value'>
                  {currencySymbol}
                  {item.amount}
                </div>
              </div>
            );
          })}
        {discountAmounts.length > 0 &&
          discountAmounts.map((item, idx) => {
            return (
              <div className='cart-summary-discount-lines'>
                <div key={idx} className='cart-summary-content-item'>
                  <div className='cart-summary-content-item-name d-flex'>
                    <span className='cart-discount-code'>
                      {translateWithI18Next('DiscountText')} ({item.couponCode})
                    </span>
                    <span
                      className='cart-discount-clear-icon'
                      data-testid={`remove-coupon-handler-${item?.couponCode}`}
                      onClick={() => removeCouponHandler(item?.couponCode)}
                    >
                      <img src={CircleCloseButton} alt='Circle Close Button' />
                    </span>
                  </div>
                  <div className='cart-summary-content-item-value'>
                    - {currencySymbol}
                    {item.amount}
                  </div>
                </div>
              </div>
            );
          })}
        {userOrderState?.couponErrorMessage && (
          <div className='cart-summary-discount-lines'>
            <div>
              <div className='discount-error'>
                <img className='discount-error-icon' src={Ellipse} alt='close' />
                <span>{userOrderState?.couponErrorMessage}</span>
              </div>
            </div>
          </div>
        )}

        {getExpiryMessage(expiryMessage)}

        {dispositionData.type === TAKEAWAY && carryBagDataExistsInCartId ? (
          <div className='cart-summary-content-item' data-testid='cart-carry-bag-text'>
            <div className='cart-summary-content-item-name'>{translateWithI18Next(largeCarryBagText)}</div>
            <div className='cart-summary-content-item-value'>
              {currencySymbol}
              {carryBagDataPrice?.toFixed(2)}
            </div>
          </div>
        ) : null}
        {addHopeDataExistsInCartId ? (
          <div className='cart-summary-content-item' data-testid='cart-add-hope-text'>
            <div className='cart-summary-content-item-name'>{translateWithI18Next(addHopeText)}</div>
            <div className='cart-summary-content-item-value'>
              {currencySymbol}
              {addHopeDataPrice?.toFixed(2)}
            </div>
          </div>
        ) : null}
      </div>

      {dispositionData.type === TAKEAWAY && carryBagDataId ? (
        <div className='cart-carry-bag-container'>
          <input
            type='checkbox'
            className='cart-carry-bag-checkbox'
            data-testid='cart-carry-bag-checkbox'
            checked={!!carryBagDataExistsInCartId}
            id={carryBagDataId}
            onChange={e => addSpecialItemInCart(e, carryBagDataExistsInCartId)}
          />
          <label className='cart-carry-bag-header' htmlFor={carryBagDataId}>
            <span>{`${currencySymbol}${carryBagDataPrice.toFixed(2)} `}</span>
            <span>{translateWithI18Next(CARRY_BAG)}</span>
          </label>
        </div>
      ) : null}
      {addHopeDataId ? (
        <div className='cart-add-hope-container'>
          <input
            type='checkbox'
            className='cart-add-hope-checkbox'
            data-testid='cart-add-hope-checkbox'
            checked={!!addHopeDataExistsInCartId}
            id={addHopeDataId}
            onChange={e => addSpecialItemInCart(e, addHopeDataExistsInCartId)}
          />
          <label htmlFor={addHopeDataId} className='cart-add-hope-content'>
            <div className='cart-add-hope-header'>
              <span>{`${translateWithI18Next(DONATE)} `}</span>
              <span>{`${currencySymbol}${addHopeDataPrice.toFixed(2)} `}</span>
              <span>{translateWithI18Next(ADD_HOPE_HEADER)}</span>
            </div>
            <div className='cart-add-hope-text'>{translateWithI18Next(ADD_HOPE_TEXT)}</div>
          </label>
          <img className='cart-add-hope-image' alt='Add hope logo' src={AddHope} />
        </div>
      ) : null}
      {isMobile ? (
        <div
          className={
            (checkoutButton && 'cart-summary-checkout-button-mobile') || 'cart-summary-checkout-button-mobile fixed'
          }
        >
          <ButtonComp
            className='button redButton cart-summary-checkout-button'
            ariaLable='checkout'
            onClick={e => navigateToCheckout(e)}
            data-testid='navigation-checkout-mobile'
            disabled={disableCheckout}
          >
            <span>{translateWithI18Next(CHECKOUT)}</span>
            <span>
              {currencySymbol}
              {totalAmount}
            </span>
          </ButtonComp>
        </div>
      ) : (
        <ButtonComp
          className='button redButton cart-summary-checkout-button'
          data-testid='navigation-checkout-desktop'
          onClick={e => navigateToCheckout(e)}
          disabled={disableCheckout}
        >
          <span>{translateWithI18Next(CHECKOUT)}</span>
          <span>
            {currencySymbol}
            {totalAmount}
          </span>
        </ButtonComp>
      )}
    </div>
  );
};

export default CartSummaryCard;
